module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"paragraph":"Você é pai, mãe ou responsável legal de algum dependente? Se sim, complete seus dados abaixo para poder controlar seu acervo. Tendo mais de um dependente, adicione-o depois editando seu perfil.","title":"Novo dependente"}}')
  delete Component.options._Ctor
}
